import React, { useMemo } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { HeaderSection } from "../HeaderSection";
import { Model } from "../Model";
import { Title } from "../Title";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import styled from "styled-components";
import Calendar from "../../../organisms/Calendar";
import { haceUnAno, stringADate, unAnoMas } from "../../../../utils/dateUtils";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DatosTransporte from "../DatosTransporte/DatosTransporte";
import Resumen from "../Resumen/Resumen";
import DatosBasicos from "../DatosBasicos/DatosBasicos";
import SuccessButton from "../../../organisms/SuccessButton";
import { useWizard } from "../../../../hooks/wizard";
import { useListarAsistenciasEnRango } from "../../../../services/asistenciaServicios";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { usePasoReservaGuarderia } from "../pasoReservaGuarderia";

function FechasGuarderia({ model }: { model: Model }) {
  const { avanza, vuelve, volver, avanzar } = useWizard();
  const { currentModel, definirFechasGuarderia } =
    usePasoReservaGuarderia(model);

  const {
    data: asistenciasHaceUnAno,
    isLoading: asistenciasHaceUnAnoIsLoading,
    isSuccess: asistenciasHaceUnAnoIsSuccess,
    isError: asistenciasHaceUnAnoIsError,
  } = useListarAsistenciasEnRango(haceUnAno(), unAnoMas(), model.idMascota);

  const fechasReservadasAnteriormente = useMemo(() => {
    if (!asistenciasHaceUnAno || !asistenciasHaceUnAnoIsSuccess) {
      return [];
    }
    return asistenciasHaceUnAno.map((asistencia) =>
      stringADate(asistencia.fecha)
    );
  }, [asistenciasHaceUnAno, asistenciasHaceUnAnoIsSuccess]);

  const diasTotales =
    currentModel.diasIndividualesGuarderia + (currentModel.plan?.dias || 0);

  const diasRestantes = diasTotales - currentModel.fechasProgramadas.length;
  const canAddMoreDates = diasRestantes > 0;

  const puedeAvanzar = diasRestantes === 0;

  const onDateClick = (date: Date) => {
    let fechas = currentModel.fechasProgramadas;
    const exists = fechas.some((f) => f.getTime() === date.getTime());

    let fechasActualizadas: Date[] = [];

    if (exists) {
      fechasActualizadas = fechas.filter((f) => f.getTime() !== date.getTime());
    } else {
      fechasActualizadas = [...fechas, date];
    }

    definirFechasGuarderia({ fechas: fechasActualizadas });
  };

  if (avanza) {
    if (currentModel.contrataTransporte) {
      return <DatosTransporte model={currentModel} />;
    } else {
      return <Resumen model={currentModel} />;
    }
  }

  if (vuelve) {
    return <DatosBasicos model={currentModel} />;
  }

  if (asistenciasHaceUnAnoIsError) {
    return <ServerErrorModal />;
  }

  return (
    <Row className="justify-content-center">
      <Col className="col-10">
        <HeaderSection className="pt-2 pb-2">
          <Title>
            Fechas de reserva
            <IconContainer>
              <CalendarMonthIcon sx={{ fontSize: 28 }} />
            </IconContainer>
          </Title>
        </HeaderSection>
        <Row className="mb-3">
          <div className="mb-2">Días por agendar: {diasRestantes}</div>
          <label className="mb-2">Elija fechas de agendamiento:</label>
          <Col className="col-12">
            {asistenciasHaceUnAnoIsLoading && <div>Cargando fechas...</div>}
            {asistenciasHaceUnAnoIsLoading && <div>Cargando fechas...</div>}
            <StyledCalendar
              onDateClick={onDateClick}
              canAddMoreDates={canAddMoreDates}
              disabledDates={fechasReservadasAnteriormente}
              preSelectedDates={currentModel.fechasProgramadas}
            />
          </Col>
        </Row>

        <Row className="mb-2 justify-content-between">
          <Col>
            <Button
              type={"button"}
              style={{ width: "fit-content" }}
              onClick={volver}
            >
              <ArrowBackIcon sx={{ fontSize: 20 }} />
              Volver
            </Button>
          </Col>
          <Col className="d-flex justify-content-end">
            <SuccessButton
              type={"button"}
              style={{ width: "fit-content" }}
              disabled={!puedeAvanzar}
              onClick={avanzar}
            >
              Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
            </SuccessButton>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

const IconContainer = styled("span")`
  display: relative;
  margin-left: 8px;
  color: ${(props) => props.theme.colors.main};
`;

const StyledCalendar = styled(Calendar)`
  width: 100%;
  border-radius: 5px;
  padding: 0%;
`;

export default FechasGuarderia;
